import React from 'react';
import { ArrowRight, Phone } from 'lucide-react';
export function Hero() {
  return <section className="relative md:h-[920px] flex items-center pt-36 md:pt-20" data-id="element-73">
      {/* Background Image */}
      <div className="absolute inset-0 -z-10" style={{
      backgroundImage: 'url("https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&q=80")',
      backgroundPosition: 'center',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat'
    }} data-id="element-74">
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-gradient-to-br from-brand-blue/70 via-brand-blue/60 to-brand-blue/50" data-id="element-75"></div>
      </div>

      {/* Wave Shape Divider */}
      <div className="absolute bottom-0 left-0 right-0 z-10 translate-y-1" data-id="element-76">
        <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto" preserveAspectRatio="none" data-id="element-77">
          <path d="M0 120L60 110C120 100 240 80 360 70C480 60 600 60 720 65C840 70 960 80 1080 85C1200 90 1320 90 1380 90L1440 90V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0V120Z" fill="#FFFFFF" data-id="element-78" />
        </svg>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full pt-4 pb-[127px] md:pb-32" data-id="element-79">
        <div className="max-w-4xl" data-id="element-80">
          <div className="inline-block bg-white/10 backdrop-blur-sm px-3 py-1.5 md:px-4 md:py-2 rounded-full mb-4 md:mb-6 border border-white/20" data-id="element-81">
            <p className="text-white/90 text-xs md:text-sm font-medium tracking-wide" data-id="element-82">
              CA License #947943 • Serving Fresno Since 1997
            </p>
          </div>

          <h1 className="text-4xl md:text-[4rem] font-semibold text-white leading-[1.15] mb-4 md:mb-6" data-id="element-83">
            28 Years Building
            <br data-id="element-84" />
            Fresno Homes
          </h1>

          <p className="text-lg md:text-2xl text-white/90 mb-6 md:mb-10 max-w-2xl leading-relaxed font-body" data-id="element-85">
            Licensed general contractor specializing in custom kitchens,
            bathrooms, and home remodeling across the Central Valley.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 md:gap-4 mb-8 md:mb-12" data-id="element-86">
            <a href="#contact" className="group bg-brand-blue hover:bg-opacity-90 text-white text-center px-6 md:px-8 py-3 md:py-4 font-semibold text-base md:text-lg transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 flex items-center justify-center gap-2" data-id="element-87">
              Get a Free Quote
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-88" />
            </a>
            <a href="tel:559-288-0499" className="group bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white border-2 border-white/30 text-center px-6 md:px-8 py-3 md:py-4 font-semibold text-base md:text-lg transition-all flex items-center justify-center gap-2" data-id="element-89">
              <Phone className="w-5 h-5" data-id="element-90" />
              559-288-0499
            </a>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-3 gap-4 md:gap-6 max-w-2xl" data-id="element-91">
            <div className="text-center sm:text-left" data-id="element-92">
              <div className="text-2xl md:text-4xl font-semibold text-white mb-1" data-id="element-93">
                28+
              </div>
              <div className="text-xs md:text-sm text-white/70 font-medium" data-id="element-94">
                Years Experience
              </div>
            </div>
            <div className="text-center sm:text-left" data-id="element-95">
              <div className="text-2xl md:text-4xl font-semibold text-white mb-1" data-id="element-96">
                500+
              </div>
              <div className="text-xs md:text-sm text-white/70 font-medium" data-id="element-97">
                Projects Completed
              </div>
            </div>
            <div className="text-center sm:text-left" data-id="element-98">
              <div className="text-2xl md:text-4xl font-semibold text-white mb-1" data-id="element-99">
                5★
              </div>
              <div className="text-xs md:text-sm text-white/70 font-medium" data-id="element-100">
                Google Rating
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Down Indicator - hidden on mobile */}
      <div className="absolute bottom-8 right-8 z-10 animate-bounce hidden md:block" data-id="element-101">
        <div className="flex flex-col items-center gap-2 text-white/70 hover:text-white transition-colors cursor-pointer" data-id="element-102">
          <span className="text-xs font-medium tracking-wider" data-id="element-103">SCROLL</span>
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-104">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" data-id="element-105" />
          </svg>
        </div>
      </div>
    </section>;
}